import { RamoatividadeService } from './../../../service/cliente/ramoatividade.service';
import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { RamoAtividadeModel } from 'app/model/cliente/ramoatividade.model';
import { ClienteService } from 'app/service/cliente/cliente.service';
import * as CryptoJS from 'crypto-js';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Component({
  selector: 'app-ramoatividade',
  templateUrl: './ramoatividade.component.html',
  styleUrls: ['./ramoatividade.component.scss']
})
export class RamoatividadeComponent implements OnInit {

  public arrayString: string;
  public creatorRamo = false;
  public editorRamo = false;
  public deleteRamo = false;
  public listarRamo = false;
  public superUser = false;
  public loading = true;

  @ViewChild('cardAdd') targetEl: ElementRef;
  @ViewChild('ramoAtividadeInput') ramoAtividadeInput: ElementRef;


  public page : ResponsePageable;

  public submit = false;

  public edited = false;
  public editado = false;
  public errorAlert = false;
  public successDelete = false;

  ramoAtividade = {} as RamoAtividadeModel;
  ramoAtividades: RamoAtividadeModel[];
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  public pageAtual = 0;

  constructor(private clienteService: ClienteService,
    private _snackBar: MatSnackBar,
    private permissionService: PermissoesService) { }

  ngOnInit() {
    this.listarRamoAtividade(0, 10);
    this.getAuthority();
  }

  listarRamoAtividade(page, size){
    this.clienteService.getPageRamoAtividade(page, size).subscribe(res => {
      this.page = res;
      this.ramoAtividades = this.page.content;
      this.loading = false;
    });
  }

  changePage(event) {
    this.listarRamoAtividade(event.page, event.size);
    this.pageAtual = event.page;
   }

   onSubmit(){
     this.submit = true;
   }

   postSubmit(){
    this.submit = false;
    this.ramoAtividadeInput.nativeElement.value = '';
    this.ramoAtividade.descricao = null;
  }

  listRamosAtividade(){
    this.clienteService.getRamoAtividade().subscribe(data =>{
      this.ramoAtividades = data.content;
    });
  }

  scroll() {
    this.targetEl.nativeElement.scrollIntoView();
  }

  saveOrEdit() {
    if (this.ramoAtividade.id !== undefined) {
      this.editarRamoAtividade();
    } else {
      this.cadastrarRamoAtividade();
    }
  }

  editarRamoAtividade() {
    this.clienteService.putRamo(this.ramoAtividade).subscribe(() => {
      this.ramoAtividade = new RamoAtividadeModel();
        this.listarRamoAtividade(this.pageAtual, 10);
        this.openSnackBarSuccess('Ramo de Atividade atualizado com sucesso !');
        this.postSubmit();
    }, err => {
      console.error(err);
      this.openSnackBarError('Erro ao tentar atualizar o Ramo de atividade !');
    });
  }

  cadastrarRamoAtividade() {
    this.clienteService.postRamo(this.ramoAtividade).subscribe(ramoAtividade => {
        this.ramoAtividade = new RamoAtividadeModel();
        this.listarRamoAtividade(0, 10);
        this.openSnackBarSuccess('Ramo de Atividade salvo com sucesso !');
        this.postSubmit();
    } , err => {
      console.log(err);
      this.openSnackBarError('Erro ao tentar salvar o Ramo de atividade !');
    });
  }

  editarTipoReajuste(ramoAtividade: RamoAtividadeModel){
    this.ramoAtividade = { ...ramoAtividade}
  }

  confirmeExclusao(id: number){
    var confirme = confirm("Tem certeza que deseja excluir este ramo de atividade ?")
    if(confirme == true){
      this.deleteRamoAtividade(id);
    } else {
      console.log("Cancelou exclusão!");
    }
  }

  deleteRamoAtividade(id:number){
    this.clienteService.deleteRamo(id).subscribe(ramoAtividade => {
        this.ramoAtividade = new RamoAtividadeModel();
        this.listarRamoAtividade(0, 10);
        this.openSnackBarSuccess('Ramo de atividade excluído com sucesso !');
    }, err => {
      if(err.status == 500){
        this.openSnackBarError('Erro ao excluir! Este ramo de atividade está sendo usado por um cliente.');
      }
      console.log('error', err.status);
    })

  }

  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_EMPRESA')) {
      this.creatorRamo = true;
    }
    if (this.arrayString.includes('EDIT_EMPRESA')) {
      this.editorRamo = true;
    }
    if (this.arrayString.includes('LIST_EMPRESA')) {
      this.listarRamo = true;
    }
    if (this.arrayString.includes('DELETE_EMPRESA')) {
      this.deleteRamo = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }

 // SnackBares
 openSnackBarSuccess(message: string) {
  this._snackBar.open(message, '', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 4000,
    panelClass: ['success-snackbar']
  });
}

openSnackBarError(message: string) {
  this._snackBar.open(message,'', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 3000,
    panelClass: ['error-snackbar']
  });
}

}



// WEBPACK FOOTER //
// /app/src/app/components/cliente-components/ramoatividade/ramoatividade.component.ts